import React from 'react';

import { ContextProvider as PolicyTemplatesProvider } from 'components/Common/PolicyTemplates/Context';
import Main from './Main';

export default function Index() {
  return (
    <PolicyTemplatesProvider>
      <Main />
    </PolicyTemplatesProvider>
  );
}
